import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { EventEmitter } from "../../event";
import { LoginUser } from "../../service/api.service";

function Login(props) {
    const navigate = useNavigate();
    const classes = {
        pageBody: 'h-screen flex bg-gray-bg  animate__animated animate__fadeIn',
        loginrow: ' flex flex-col md:flex-row  m-auto shadow-2xl border-2 border-white Border  rounded overflow-hidden	',
        formName: 'w-full bg-blue-900 px-16 py-24 rounded-l formnm border-r border-white relative ',
        formContainer: 'w-full   bg-blue-600 px-16 py-24 login-f ',
        formHeading: 'text-3xl  font-light  text-black-200 text-primary mt-4 mb-4 text-center ',
        btnContainer: 'flex justify-end items-center mt-0',
        btn: 'ease-in duration-300 flex justify-center items-center font-semibold text-xl transition ease-in-out delay-150  border border-gray-300 text-white shadow-md p-3 px-6 bg-blue-600 bg-gradient-to-t from-blue-900',
        inputClass: '  pr-2    border-2 border-green-900	 bg-green-800  w-full  text-white  transition ease-in-out delay-150 ease-in duration-300  	',
        title: 'ease-in duration-300 text-5xl font-bold italic text-center text-blue-900 border-b pb-6 border-white w-80  transition ease-in-out delay-150'
    };
    const username = useFormInput('');
    const password = useFormInput('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleLogin = () => {
        setError(null);
        setLoading(true);
        if (username.value && password.value) {
            LoginUser(username.value, password.value, resp => {
                if (resp.error) {
                    setLoading(false);
                    setError(resp.message);
                } else {
                    EventEmitter.dispatch("loginChanged", "true");
                    navigate('Home', { replace: true });
                }
            })

        }
        else {
            setLoading(false);
            setError("Something went wrong. Please try again later.");
        }
    }

    return (
        <div className={classes.pageBody} style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }} >
            <div className={classes.loginrow}>
                <div className={classes.formName} style={{ backgroundImage: `url(${require('../../assets/images/spin-login-img.png')})`, backgroundPosition: "center" }} >
                    <div className={classes.title}>Virtue Report Interface</div>
                    <h1 className={classes.formHeading}> Log in to your account</h1>
                    <img src={require('../../assets/images/login-arrow.png')} alt="" className="absolute -right-8 top-2/4 -mt-8 w-14 hidden lg:block grayscale brightness-200	" />
                </div>
                <div className={classes.formContainer}>
                    <h2 className={classes.formHeading}> Log in to your account</h2>
                    <div className="relative mt-6 relative bg-green-800 drop-shadow-lg lg:w-96 mb-4 flex flex-row input-col  items-center h-13">
                        <img src={require('../../assets/images/username-icon.png')} alt="" className="" />
                        <input
                            id='email'
                            label='Email'
                            type='email'
                            placeholder='Your email'
                            {...username}
                            className={classes.inputClass}
                        />
                        <img src={require('../../assets/images/username-icon.png')} alt="" className="absolute brightness-100	  " />
                    </div>
                    <div className="relative mt-6 relative bg-green-800 drop-shadow-lg lg:w-96 mb-6 flex flex-row input-col  items-center h-13">
                        <img src={require('../../assets/images/password-icon.png')} alt="" className="" />
                        <input
                            id='password'
                            label='Password'
                            type='password'
                            {...password}
                            placeholder='Your Password'
                            className={classes.inputClass} />
                        <img src={require('../../assets/images/password-icon.png')} alt="" className="absolute    brightness-100	 " />
                    </div>
                    <div className="w-96 flex flex-row justify-between mb-4">
                        <div className="mr-2 leading-5	">
                            {error && <><small style={{ color: '#ccc' }}>{error}</small><br /></>}
                        </div>
                        <div className={classes.btnContainer}>
                            <button type='submit' onClick={handleLogin} className={classes.btn}>
                                <img src={require('../../assets/images/login-icon.png')} alt="" className="mr-2" />
                                {!loading && 'LOGIN'}{loading && 'Loading'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const useFormInput = initialValue => {
    const [value, setValue] = useState(initialValue);
    const handleChange = e => {
        setValue(e.target.value);
    }
    return {
        value,
        onChange: handleChange
    }
}


export default Login;